import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { CodeMappingsRenderer } from './components/code-mapping-renderer';
import { actionCreators } from './actions';
import { codeMappingsTranslation } from './constants';
import { CodeMappingsListState } from './types-store';
import { blockAccessCodeMappings } from 'app/area/code-mappings/constants';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import { getCodeMappingAccess } from 'app/area/code-mappings/common/get-code-mappings-access';
import { hasTranslationsLoaded } from 'app/infrastructure/translate/selectors';

export type CodeMappingsProps = DefaultContainerProps & CodeMappingsListState & typeof actionCreators;

class CodeMappingsComponent extends React.PureComponent<CodeMappingsProps> {
  public static statePath: string = STATE.codeMappings;

  public componentDidUpdate(prevProps: CodeMappingsProps) {
    const { importSet: { value: importSetValue } = {}, modifiedItems, translation, saveChanges } = this.props;

    if (prevProps.modifiedItems.length === 0 && modifiedItems.length > 0) {
      saveChanges(importSetValue, modifiedItems, translation.validation_error);
    }
  }

  public componentDidMount() {
    scrollToTop();
    if (hasTranslationsLoaded(this.props.translation)) {
      this.initList();
    }
  }

  public componentWillUnmount() {
    this.props.clearList();
  }

  private initList() {

    const { sharedState, displayError, translation } = this.props;

    if (!getCodeMappingAccess(sharedState)) {
      displayError(blockAccessCodeMappings(translation).text);
      navigate.toStartupView(true);
    }
  }

  public render() {

    const {
      modifiedItems, fileName, importSet, missingMappingsExists, listItems, fetchingList, codetableIds,
      validation, codetableAccess, fetchingCodetableAccess, codetableOptions, metadata, fetchingItemId,
      updatingExternalValue, sharedState, params: { id } = {}, translation, loadList, loadItem, modifyItem,
      copyToAll, loadMetadata, loadCodetableOptions, loadCodetablesAccess, loadCategoryOptions
    } = this.props;

    if (!getCodeMappingAccess(sharedState)) {
      return null;
    }

    return <CodeMappingsRenderer
      id={parseInt(id, 10)}
      modifiedItems={modifiedItems}
      fileName={fileName}
      importSet={importSet}
      listItems={listItems}
      missingMappingsExists={missingMappingsExists}
      fetchingList={fetchingList}
      fetchingItemId={fetchingItemId}
      validation={validation}
      loadList={loadList}
      loadItem={loadItem}
      codetableIds={codetableIds}
      modifyItem={modifyItem}
      copyToAll={copyToAll}
      translation={translation}
      codetableOptions={codetableOptions}
      loadCodetableOptions={loadCodetableOptions}
      loadCategoryOptions={loadCategoryOptions}
      loadMetadata={loadMetadata}
      metadata={metadata}
      codetableAccess={!fetchingCodetableAccess && codetableAccess}
      loadCodetablesAccess={loadCodetablesAccess}
      updatingExternalValue={updatingExternalValue} />;
  }
}

const container = containerFactory(CodeMappingsComponent, actionCreators, {}, codeMappingsTranslation);

export { container as CodeMappings };
